import React from 'react';
import UserStore from './store';
import TeamStore from './teamStore';

export const AuthUserContext = React.createContext(null);
export const UserContext = React.createContext(new UserStore());
export const TeamContext = React.createContext(new TeamStore());
